export default function DemoBanner() {
  return (
    <div className="mb-5 flex items-center justify-center rounded-xl border border-[#d6006e] bg-[#6b0030] px-4 py-2.5 text-center text-sm font-black uppercase tracking-[0.16em] text-white" role="status">
      Demo — not a real rating · cannot be shared with funding partners
    </div>
  );
}
